var $18b8fa80cdc50d05$exports = {};
$18b8fa80cdc50d05$exports = {
    "longPressMessage": `\u{9577}\u{62BC}\u{3057}\u{307E}\u{305F}\u{306F} Alt+\u{4E0B}\u{77E2}\u{5370}\u{30AD}\u{30FC}\u{3067}\u{30E1}\u{30CB}\u{30E5}\u{30FC}\u{3092}\u{958B}\u{304F}`
};


export {$18b8fa80cdc50d05$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
